import '../../src/assets/jssip-3.10.0.js'
import audio from '../../static/audio/incoming-call-ringtone.wav'
import sosRing from '../../static/audio/alarm.wav'
import backAudio from '../../static/audio/ringbacktone.wav'
let MyWebrtc = function () {
  let MediaStreamTrack = null;
  let outgoingSession = null;
  let incomingSession = null;
  let currentSession = null;
  let getJsSipgetIp = null; //存取全局IP
  let getJsSipPhoneNumber = null; //存取全局号码
  let getJsSipgetPassWord = null; //存取全局密码
  let getstatus1 = null;
  let getstatus2 = null;
  let globalRegisteState = '未注册';//注册状态
  let globalCallPhoneStates = "未通话";//通话状态
  let judgeIsVoice = "";//判断是语音拨打还是视频拨打
  let isUseSelf = null;//主要针对主控台，每个分机上面的语音拨打、视频拨打与自动接听分离。
  let globalStatus = false
  let Datas = null;
  let userAgent = null;

  let ringbackAudio = new window.Audio(backAudio);
  ringbackAudio.muted=true
  ringbackAudio.loop = true;
  let ringAudio = document.createElement('audio')
  ringAudio.loop=true

  let remoteAudio = new window.Audio();
  remoteAudio.autoplay = true;

  let answer = null
  let hangup = null
  let ring = null

  let constraints = {
    audio: true,
    video: true
  };

  //jssip实例初始化
  this.jssipAgent = function (WEBSocket, JsSipPhoneNumber, JsSipgetIp, JsSipgetPassWord, ringCallBack, hangupCallBack,answerCallBack, Registerstate, Callstate, callback) {
    getJsSipPhoneNumber = JsSipPhoneNumber
    getJsSipgetIp = JsSipgetIp
    getJsSipgetPassWord = JsSipgetPassWord
    getstatus1 = Registerstate
    getstatus2 = Callstate
    answer = answerCallBack
    ring = ringCallBack
    hangup = hangupCallBack

    let phoneNumber = JsSipPhoneNumber + '@'
    let getIp = JsSipgetIp
    getJsSipgetIp = JsSipgetIp
    let sip_uri_ = ('sip:' + phoneNumber + getIp).toString()
    let ws_uri_ = WEBSocket
    let sip_password_ = JsSipgetPassWord
    let transport = ws_uri_.split('://')[0]
    JsSIP.C.SESSION_EXPIRES = 120, JsSIP.C.MIN_SESSION_EXPIRES = 120
    let socket = new JsSIP.WebSocketInterface(ws_uri_)
    let configuration = {
      sockets: [socket],
      uri: sip_uri_,
      register: true,
      password: sip_password_,
      contact_uri: sip_uri_ + ';transport=' + transport,
      ws_servers: ws_uri_,
      debug:true
      //session_timers: false
    }

    userAgent = new JsSIP.UA(configuration)

    userAgent.on('registered', function (data) {
      console.log('已注册', data)
      //console.info("registered: ", data.response.status_code, ",", data.response.reason_phrase);
      //注册状态显示
      if (getstatus1) {
        getstatus1.innerText = '已注册'
      }
      globalRegisteState = '已注册'
      callback(true)
    })
    //未注册
    userAgent.on('unregistered', function (e) {
      console.log('未注册', e)
      if (getstatus1) {
        getstatus1.innerText = '未注册'
      }
      globalRegisteState = '未注册'
    })
    userAgent.on('registrationFailed', function (data) {
      console.log('注册失败 ', data)
      //注册状态显示
      if (getstatus1) {
        getstatus1.innerText = '注册失败'
      }
      globalRegisteState = '注册失败'
      callback(false)
    })
    //1.在注册到期之前发射几秒钟。如果应用程序没有为这个事件设置任何监听器，JsSIP将像往常一样重新注册。
    userAgent.on('registrationExpiring', function () {

      //过期之后将自动重新注册
      console.warn('注册过期')
      //重新注册
      userAgent.register()
      //jssipAgent(JsSipPhoneNumber,JsSipgetIp,JsSipgetPassWord,remoteVideo,status1,status2);
    })
    //为传入或传出的会话/呼叫
    userAgent.on('newRTCSession', function (data) {
      if (globalStatus) {
        data.session.terminate()
      }
      Datas = null;
      if (data.originator == 'remote') { //incoming call

        console.info('incomingSession, answer the call')
        incomingSession = data.session
        Datas = data.session
      } else {
        console.info('outgoingSession')
        outgoingSession = data.session
        outgoingSession.on('connecting', function (data) {
          //通话状态
          if (getstatus2) {
            getstatus2.innerText = '连接中'
          }
          globalCallPhoneStates = '连接中'
          console.info('onConnecting - ', data.request)
          currentSession = outgoingSession
          outgoingSession = null
          //弹屏
          if (!judgeIsVoice) {
            ring()
          }
        })

      }
      //远程挂断事件
      data.session.on('ended', function (data) {
        //回调关闭方法
        hangup(true)
        console.log('call end', data)
        remoteAudio.srcObject = null
        ringbackAudio.muted = false;
        ringbackAudio.pause();
        ringAudio.pause()
        //通话状态
        if (Callstate) {
          Callstate.innerText = '已挂断'
        }
        globalCallPhoneStates = '已挂断'
      })
      data.session.on('accepted', function (data) {
        console.info('onAccepted - ', data)
        setTimeout(function (){
          ringAudio.muted = false;
          ringAudio.pause()
          ringbackAudio.muted = false;
          ringbackAudio.pause();
        },500)

        if (data.originator == 'remote') {
          currentSession = incomingSession
          incomingSession = null
          //通话状态
          if (getstatus2) {
            getstatus2.innerText = '通话中'
          }
          globalCallPhoneStates = '通话中'
        } else {
          if (getstatus2) {
            getstatus2.innerText = '通话中'
          }
          globalCallPhoneStates = '通话中'
        }
      })
      data.session.on('confirmed', function (confirm) {

        if (confirm.originator == 'remote' && currentSession == null) {
          currentSession = incomingSession
          incomingSession = null
          //通话状态
          if (getstatus2) {
            getstatus2.innerText = '通话中'
          }
          globalCallPhoneStates = '通话中'

        }

        // Always pause ringback audio when call is confirmed
        ringbackAudio.muted = false
        ringbackAudio.pause()

        if (!judgeIsVoice) {
          confirm.originator == 'remote' ? ring(data.session._connection.getRemoteStreams()[0]) : answer(data.session._connection.getRemoteStreams()[0])
        }else {
          const stream = new MediaStream();
          const receivers = data.session._connection.getReceivers();
          if (receivers) {
            receivers.forEach((receiver) => stream.addTrack(receiver.track));
          }
          remoteAudio.srcObject = stream;
          // 最后都要播放
          remoteAudio.oncanplay = () => {
            remoteAudio.play();
          };
        }
      })
      data.session.on('sdp', function (data) {
        if (judgeIsVoice) {
          if (data.type === 'answer' && data.sdp.indexOf('m=video ') > -1) {
            var changeSDP = ''
            var snsArr = data.sdp.split(/[(\r\n)\r\n]+/)
            var videoCode = false
            snsArr.forEach((item,index)=>{
              var str = snsArr[index]
              if (str.indexOf('m=video ') > -1) {
                videoCode = true
              }
              if (!videoCode) {
                changeSDP = changeSDP + str+'\n'
              }
            })
            data.sdp = changeSDP
          }
        }
      })
      data.session.on('progress', function (data) {
        console.log('progress',data.originator)
        if (data.originator == 'remote') {
          //通话状态
          //此处写入振铃音
          setTimeout(function (){
            const remoteDescription = currentSession && currentSession._connection ? currentSession._connection.remoteDescription : null
            if (remoteDescription) {
              const receivers = currentSession._connection.getReceivers()
              if (receivers) {
                const stream = new MediaStream()
                receivers.forEach((receiver) => {
                  if (receiver.track.kind == 'audio') {
                    stream.addTrack(receiver.track)
                  }
                })
                remoteAudio.srcObject = stream
                // 最后都要播放
                remoteAudio.oncanplay = () => {
                  remoteAudio.play()
                }
                ringAudio.pause()
              } else {
                ringbackAudio.muted = false
                ringbackAudio.play()
              }
            } else {
              ringbackAudio.muted = false
              ringbackAudio.play()
            }
          },500)
        }
      })
      data.session.on('peerconnection', function (data) {
        console.log('peerconnection')
        /*data.peerconnection.onaddstream = function (ev) {
          ringbackAudio.muted = false
          ringbackAudio.pause()
          if (!remoteAudio.srcObject){
            if (!judgeIsVoice){
              //回调视频方法
              answer(ev.stream)
            }
            remoteAudio.srcObject = ev.stream
          }
        }*/

      })

      data.session.on('failed', function (e) {
        remoteAudio.srcObject = null
        ringAudio.pause()
        if (incomingSession != null) {
          stopRing()
          incomingSession = null
        }
        !judgeIsVoice ? hangup(true) : null
      })

      if (data.session.direction === 'incoming') {
        if (!globalStatus) {
          remoteAudio.muted = false
          /*incomingCallAudio.muted = false
          incomingCallAudio.play()*/
        }
      }
    })

    userAgent.start()

  }

  // Register callbacks to desired call events
  let eventHandlers = {
    'progress': function (e) {
      globalCallPhoneStates = "连接中";
    },
    'failed': function (e) {
      ringbackAudio.muted = false;
      ringbackAudio.pause();
      if (e.cause == "Busy") {
        globalCallPhoneStates = "用户正忙";
      } else {
        //通话状态
        globalCallPhoneStates = "拨打失败";
      }
    },
    'ended': function (e) {
      //隐藏本地视频区域
      //selfViewWap.style.display = "none";
      //通话状态
      globalCallPhoneStates = "已挂断";

    },

    'confirmed': function (e) {
      ringbackAudio.muted=false
      ringbackAudio.pause()
    }
  };

  this.setStatus = function (status) {
    globalStatus = status
  }

  this.customerRing = function (isSos) {

    if (isSos) {
      ringAudio.src = sosRing
    } else {
      ringAudio.src = audio
    }
    ringAudio.loop=true
    ringAudio.addEventListener('ended', ringListener, false)
    ringAudio.play()
  }

  function stopRing() {
    if (ringAudio && ringAudio.played) {
      ringAudio.pause()
      ringAudio.removeEventListener('ended', ringListener, false)
      ringAudio.src = null
    }
  }

  function ringListener() {
    if (ringAudio && ringAudio.ended) {
      ringAudio.play()
    }
  }

  //语音拨打
  this.JsSip_VoiceCall = function (callPhone, isVideo, isUseSelfFun) {
    judgeIsVoice = !isVideo;//判断是语音拨打还是视频拨打
    let sip = "sip:";
    let getIp = getJsSipgetIp;
    let sip_phone_number_ = (sip + callPhone + '@' + getIp).toString()
    //置空语音流
    isUseSelf = isUseSelfFun;
    remoteAudio.srcObject = null
    constraints.video = isVideo
    let options = {
      'eventHandlers': eventHandlers,
      'mediaConstraints': constraints,
      'mediaStream': null
    };
    outgoingSession = userAgent.call(sip_phone_number_, options);
  }
  //语音接听
  this.VoiceAnswer = function (isVideo) {
    stopRing()
    if(isUseSelf){
      isVideo = "voice" === isUseSelf ? false : "noVoice" === isUseSelf ? true : isVideo;
    }
    judgeIsVoice = !isVideo
    //console.log("datas session-----------",Datas)
    if(Datas){
      constraints.video = isVideo
      Datas.answer({
        'mediaConstraints': constraints,
        'mediaStream': null
      });
    }
    if (getstatus2) {
      getstatus2.innerText = "通话中";
    }
    globalCallPhoneStates = "通话中";
  }

  //挂断
  this.JsSip_hangUpPhone = function () {

    //关闭本地摄像头
    //this.closeLocalCapature();
    //userAgent.stop();//保存当前的注册状态并在正常注销并终止活动会话（如果有）后断开与信令服务器的连接。
    var options = {
      'status_code':486
    };

    if (incomingSession != null) {
      stopRing()
      incomingSession.terminate(options);
    } else {
      userAgent.terminateSessions(options); //终止当前对话
    }
    //通话状态
    if (getstatus2) {
      getstatus2.innerText = "已挂断";
    }
    globalCallPhoneStates = "已挂断";
    //当挂断电话要重新调用注册接口
    //this.jssipAgent(getJsSipPhoneNumber,getJsSipgetIp,getJsSipgetPassWord,getRemoteVideo,getstatus1,getstatus2);
  }
  //关闭本地摄像头
	this.closeLocalCapature = function () {
		MediaStreamTrack && MediaStreamTrack.stop();
	}
  //注销
  this.JsSip_clearRegested = function () {
    let options = {
      all: true
    };
    userAgent.unregister(options);
    console.log('unregister')
    //userAgent.stop();//保存当前的注册状态并在正常注销并终止活动会话（如果有）后断开与信令服务器的连接。
  }
  //注册状态
  this.getRegisterState = function () {
    return globalRegisteState;
  }
  //通话状态
  this.callPoneState = function () {
    return globalCallPhoneStates;
  }
};

export default MyWebrtc



// WEBPACK FOOTER //
// ./src/libs/webrtc.js